"use strict";
/**
 * Do not edit directly
 * This file is automatically generated
 **/
Object.defineProperty(exports, "__esModule", { value: true });
exports.light = void 0;
exports.light = {
    "background": {
        "default": "#ffffff",
        "contrast": "#f5f6fa",
        "hover": "rgba(0, 0, 0, 0.06)",
        "selected": "rgba(0, 0, 0, 0.1)",
        "overlay": "#ffffff",
        "primary": "#efecfb",
        "critical": "#fbefeb",
        "warning": "#fdf5eb",
        "success": "#ebf6ef",
        "highlighted": {
            "primary": "#633fd3",
            "success": "#459B64",
            "warning": "#E6A03B",
            "critical": "#D35B34"
        }
    },
    "border": {
        "default": "#e8e8e8",
        "contrast": "#d7dbeb",
        "selected": "#000000",
        "primary": "#d1c8f3",
        "critical": "#f4d2c7",
        "warning": "#f9e1c3",
        "success": "#cde9d7"
    },
    "content": {
        "default": "#000000",
        "subdued": "#666666",
        "disabled": "#b3b3b3",
        "placeholder": "#808080",
        "primary": "#633fd3",
        "success": "#459B64",
        "warning": "#E6A03B",
        "critical": "#D35B34",
        "accent": {
            "success": "#3E7957",
            "warning": "#A45E0A",
            "critical": "#B64C2F"
        },
        "above": {
            "primary": "#ffffff",
            "secondary": "#000000",
            "text": "#000000",
            "contrast": "#000000",
            "critical": "#D35B34"
        }
    },
    "interactive": {
        "primary": {
            "default": "#000000",
            "hover": "#0d0d0d",
            "pressed": "#242424"
        },
        "secondary": {
            "default": "rgba(0, 0, 0, 0.06)",
            "hover": "rgba(0, 0, 0, 0.1)",
            "pressed": "rgba(0, 0, 0, 0.12)"
        },
        "contrast": {
            "default": "#ffffff",
            "hover": "rgba(255, 255, 255, 0.9)",
            "pressed": "rgba(255, 255, 255, 0.75)"
        },
        "text": {
            "default": "rgba(0, 0, 0, 0)",
            "hover": "rgba(0, 0, 0, 0.1)",
            "pressed": "rgba(0, 0, 0, 0.12)"
        },
        "critical": {
            "default": "#fbefeb",
            "hover": "#f7dfd7",
            "pressed": "#f0c2b2"
        },
        "disabled": "#f5f6fa"
    },
    "benefits": {
        "mealVoucher": {
            "content": {
                "default": "#FF5A1A",
                "selected": "#c53700"
            },
            "background": {
                "default": "#ffeee8",
                "selected": "#ffb396"
            }
        },
        "gift": {
            "content": {
                "default": "#EF1090",
                "selected": "#a70b65"
            },
            "background": {
                "default": "#fde7f4",
                "selected": "#f891cc"
            }
        },
        "mobility": {
            "content": {
                "default": "#79CC33",
                "selected": "#558f24"
            },
            "background": {
                "default": "#f2faeb",
                "selected": "#c1e8a1"
            }
        },
        "personalWallet": {
            "content": {
                "default": "#1A96DA",
                "selected": "#126999"
            },
            "background": {
                "default": "#e7f5fc",
                "selected": "#92d0f2"
            }
        },
        "cashback": {
            "content": {
                "default": "#FCB408",
                "selected": "#b47f02"
            },
            "background": {
                "default": "#fff8e6",
                "selected": "#fedd8d"
            }
        }
    },
    "social": {
        "pot": {
            "content": {
                "default": "#1A96DA",
                "selected": "#126999"
            },
            "background": {
                "default": "#e7f5fc",
                "selected": "#92d0f2"
            }
        },
        "activity": {
            "content": {
                "default": "#79CC33",
                "selected": "#558f24"
            },
            "background": {
                "default": "#f2faeb",
                "selected": "#c1e8a1"
            }
        },
        "pulse": {
            "content": {
                "default": "#33C794",
                "selected": "#248b68"
            },
            "background": {
                "default": "#eafaf4",
                "selected": "#a0e7ce"
            }
        },
        "praise": {
            "default": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f891cc"
                }
            },
            "birthday": {
                "content": {
                    "default": "#633fd3",
                    "selected": "#41249c"
                },
                "background": {
                    "default": "#efecfb",
                    "selected": "#b7a7eb"
                }
            },
            "celebration": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f891cc"
                }
            },
            "congrats": {
                "content": {
                    "default": "#79CC33",
                    "selected": "#558f24"
                },
                "background": {
                    "default": "#f2faeb",
                    "selected": "#c1e8a1"
                }
            },
            "egoboost": {
                "content": {
                    "default": "#1A96DA",
                    "selected": "#126999"
                },
                "background": {
                    "default": "#e7f5fc",
                    "selected": "#92d0f2"
                }
            },
            "onboarding": {
                "content": {
                    "default": "#FCB408",
                    "selected": "#b47f02"
                },
                "background": {
                    "default": "#fff8e6",
                    "selected": "#fedd8d"
                }
            },
            "proanniversary": {
                "content": {
                    "default": "#FF5A1A",
                    "selected": "#c53700"
                },
                "background": {
                    "default": "#ffeee8",
                    "selected": "#ffb396"
                }
            },
            "procelebration": {
                "content": {
                    "default": "#FF5A1A",
                    "selected": "#c53700"
                },
                "background": {
                    "default": "#ffeee8",
                    "selected": "#ffb396"
                }
            },
            "thanks": {
                "content": {
                    "default": "#EF1090",
                    "selected": "#a70b65"
                },
                "background": {
                    "default": "#fde7f4",
                    "selected": "#f891cc"
                }
            }
        },
        "article": {
            "content": {
                "default": "#FCB408",
                "selected": "#b47f02"
            },
            "background": {
                "default": "#fff8e6",
                "selected": "#fedd8d"
            }
        }
    },
    "cards": {
        "black": {
            "primary": "#111111",
            "accent": "#272727"
        },
        "grey": {
            "primary": "#585858",
            "accent": "#e5e5e5"
        },
        "midnightBlue": {
            "primary": "#00084b",
            "accent": "#e5e8ff"
        },
        "gold": {
            "primary": "#c8ba95",
            "accent": "#f3f0e7"
        },
        "pink": {
            "primary": "#edc2bd",
            "accent": "#f7e5e3"
        }
    },
    "travel": {
        "carGradient": "linear-gradient(139deg, #fff8d1 0%, #f6ec99 16.15%, #ffaf79 47.19%, #991333 99.48%)",
        "trainGradient": "linear-gradient(-41deg, #008c6b 0%, #4cf0c9 48.84%, #dff6af 82.94%, #effad7 100%)",
        "flightGradient": "linear-gradient(139deg, #ccfbf0 0%, #99f7e0 21.94%, #7099ff 57.17%, #1f4199 100%)",
        "hotelGradient": "linear-gradient(135deg, #ffd2dd 0%, #ffa6bb 18.38%, #c060f5 51.55%, #631191 100%)"
    }
};
